export enum ErrorViewTypes {
  COMMON_ERROR = "COMMON_ERROR",
  SUSPENDED_ACCOUNT_ERROR = "SUSPENDED_ACCOUNT_ERROR",
}
